import React from "react";

import { Controller, useFormContext } from "react-hook-form";

import { Switch } from "src/base-components/Switch";
import { CustomConnectionForm } from "src/customConnectionNode/types";

type ResponseValidationConfigurationProps = {
  immutable: boolean;
  /**
   * Returns the flow's current output schema; snapshotted into the node
   * config when the toggle is enabled so Connect can validate against it.
   */
  getOutputSchema: () => Record<string, unknown> | null;
};

export const ResponseValidationConfiguration: React.FC<
  ResponseValidationConfigurationProps
> = ({ immutable, getOutputSchema }) => {
  const { control, setValue } = useFormContext<CustomConnectionForm>();

  return (
    <div className="mt-6 flex items-center justify-between">
      <div>
        <h3 className="font-inter-medium-12px text-gray-800">
          Validate response against output schema
        </h3>
        <span className="font-inter-normal-12px text-gray-500">
          Validate the provider&apos;s response using the flow&apos;s output
          schema
        </span>
      </div>
      <Controller
        control={control}
        name="config.response_validation_config.active"
        render={({ field }) => (
          <Switch
            dataLoc="custom-connection-node-response-validation-active"
            disabled={immutable}
            enabled={!!field.value}
            onChange={() => {
              const enabled = !field.value;
              field.onChange(enabled);
              setValue(
                "config.response_validation_config.response_schema",
                enabled ? getOutputSchema() : null,
                { shouldDirty: true },
              );
            }}
          />
        )}
      />
    </div>
  );
};
